// extracted by mini-css-extract-plugin
module.exports = {"ManualsService":"ManualsService_ManualsService__1HVC4","Main":"ManualsService_Main__2VJHY","Shadow":"ManualsService_Shadow__pb0CF"};